import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import { Link } from 'react-router-dom';
import AccordionCard from './Accordion';
import Button from '@material-ui/core/Button';
import { Box, Menu, MenuItem } from '@material-ui/core';
import zIndex from '@material-ui/core/styles/zIndex';


// import InboxIcon from '@material-ui/icons/MoveToInbox';
// import MailIcon from '@material-ui/icons/Mail';

const useStyles = makeStyles((theme) => ({
    root: {
        width: "95%",
        display: "flex",
        margin: "0px auto",
        justifyContent: "space-between",
        zIndex: 2,
        position: "relative",
        alignItems: "center",
        padding: '20px 0px'
    },
    logo: {
        width: 170.5,
        height: 45
    },
    enterHomeRoot: {
        backgroundColor: "transparent",
        border: "1px solid white",
        color: "white",
        padding: '5.5px 30px',
        margin: "1px 5px",
        '&:active': {
            backgroundColor: "transparent",
        },
        '&:hover': {
            backgroundColor: "transparent",
        }
    },
    buttuns: {
        display: "flex"
    },
    enterHome: {
        backgroundColor: "transparent",
        border: "1px solid white",
        boxShadow: 0,
        color: "white",
        padding: '5.5px 30px',
        margin: "0 5px",
        '&:active': {
            backgroundColor: "transparent",
        },
        '&:hover': {
            backgroundColor: "transparent",
        }
    },
    navbar: {
        width: 40,
        height: 40,
        [theme.breakpoints.down("sm")]: {
            border: "1px solid #B5B5B5",
            borderRadius: 7
        }
    },
    list: {
        width: "100%",
        display: "contents"
    },
    fullList: {
        width: 'auto',
    },
    item: {
        width: "100%",
        height: '70vh !important',
        overflow: 'auto',
    },
    enter: {
        backgroundColor: "white",
        border: "1px solid gray",
        padding: '5.5px 30px',
        margin: "0 5px",
        '&:active': {
            backgroundColor: "white",
        },
        '&:hover': {
            backgroundColor: "white ",
        }
    },
    openAccount: {
        backgroundColor: theme.palette.light.type2,
        color: "white",
        margin: "0 2px",
        minWidth: '150px',
        padding: '9px 10px',
        '&:active': {
            backgroundColor: theme.palette.light.type2,
        },
        '&:hover': {
            backgroundColor: theme.palette.light.type2,
        }
    },
    topBox: {
        margin: 20,
        display: "flex",
        justifyContent: "space-between",
        alignItems: 'center',
        position: "relative",
        "& svg": {
            width: 40,
            height: 38,
            cursor: "pointer",
            position: "absolute",
            top: 0,
            right: 0
        }
    },
    listItem: {
        padding: 0,
        margin: 0
    },
    itemText: {
        padding: "26px 31px",
        borderBottom: "1px solid #DCDCDC",
        margin: 0,
        textAlign: "center !important",
    },
    bottomBox: {
        height: 83,
        backgroundColor: "#DA212EAli",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        fontWeight: 600,
        padding: "0 25px",
        position: "absolute",
        bottom: 0,
        width: "100%"
    },
    header: {
        width: "100%",
        textAlign: "center",
    },
    buttons: {
        display: "flex",
        alignItems: "center",
        justifyContent: 'center',
        // flexDirection:'column',
        zIndex: 1000,
        paddingBottom: 10,
    },
    btnOtline: {
        backgroundColor: "white",
        color: "#d41217",
        margin: "0 5px",
        padding: '9px 20px',
        border: `1px solid #d41217`,
        [theme.breakpoints.down("1236")]: {
            padding: '9px 5px',
        },
        '&:hover': {
            backgroundColor: "#d41217",
            color: "white"
        },
    },
    mergeButtons: {
        width: 225,
        padding: '0px 07px',
        height: 44,
        borderRadius: 5,
        backgroundColor: '#F4F4F4',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center'
    },
    text: {
        fontSize: 14,
        marginBottom: 0,
        '&:hover': {
            color: 'red',
            cursor: 'pointer'
        }
    },
    line: {
        width: 1,
        height: 22,
        backgroundColor: 'rgba(0,0,0,0.5)'
        // border:'0.5px solid rgba(0,0,0,1)'
    },
    toggleButton: {
        '& .MuiPaper-root': {
            top: '70px !important',
            zIndex: 10000000000
        }
    },
    badge: {
        background: "#DDE0FF",
        display: 'inline-block',
        padding: "5px 8px ",
        borderRadius: 9,
        fontSize: 10,
        marginLeft: 5,
        color: '#5A68B2',

    },
    btnOms: {
        padding: '0px 16px',
        height: 44,
        borderRadius: 5,
        backgroundColor: '#FFD9D9',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        marginRight: 10,
        color: '#E60001',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        width: 160,
        [theme.breakpoints.down("1071")]: {
            marginBottom: 5,
            marginRight: 0,
            width: 220,
            justifyContent: 'center',
        },
        marginBottom: 5,
        marginRight: 0,
        width: 220,
        justifyContent: 'center',
    },
    cardButton: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        flexDirection: 'column',
        [theme.breakpoints.down("397")]: {
            // marginBottom:10,
        }
    },
    linkTitle: {
        marginRight: "20px",
        marginTop: "10px",
        display: "inline-block",
        '& .title': {
            fontSize: 14,
        },
        '&:hover .title': {
            color: 'red !important'
        }
    }
}));

export default function HeaderMobile({ home, data, flagHeader, setflagOms }) {

    const classes = useStyles();
    const [state, setState] = React.useState({ right: false });
    const [open, setOpen] = React.useState(null);
    const [openAccount, setOpenAccount] = React.useState(null);

    const toggleDrawer = (anchor, open) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ [anchor]: open });
    };

    const handelOpen = () => {
        setOpenAccount(false)
        setOpen(prev => !prev)
    }

    const handelOpenAccount = () => {
        setOpen(false)
        setOpenAccount(prev => !prev)
    }



    const list = (anchor) => (
        <div
            className={classes.list}
            role="presentation"
        >
            <Box
                className={classes.topBox}
            >
                <img
                    height={50}
                    width={211}
                    src='/assets/images/logo.png'
                    alt='' />

                <Box>
                    <svg
                        style={{ marginTop: 5 }}
                        onClick={toggleDrawer(anchor, false)}
                        onKeyDown={toggleDrawer(anchor, false)}
                    >
                        <use xlinkHref="/sprit.svg#close"></use>
                    </svg>
                </Box>

            </Box>

            <Divider />

            <List
                className={classes.item}
                style={{ padding: 0 }}
            >
                {
                    data.map((item, index) => (
                        <AccordionCard data={item} key={index} />
                    ))
                }
            </List>

            {/* <Box className={classes.buttons}>
                <a href={'https://poyan.exirbroker.com/'}
                    target='_blank'
                    rel="noopener noreferrer">
                    <Button className={!home ? classes.btnOtline : classes.btnOtline}>
                        ورود به سامانه معاملاتی
                    </Button>
                </a>
                <a href={'https://reg.pouyanbroker.ir'}
                    target='_blank'
                    rel="noopener noreferrer">
                    <Button className={!home ? classes.openAccount : classes.openAccount}>
                        افتتاح حساب
                    </Button>
                </a>
            </Box>
            <Button style={{maxWidth : 200 , margin:'auto'}} className={home ? classes.openAccount : classes.openAccountRed}
                    onClick={() => setflagOms(true)}
                >
                    تغییر پنل معاملاتی
                </Button> */}
            <div className={classes['cardButton']} style={{ alignItems: open ? 'center' : 'center' }}>
                <div className={classes['btnOms']} onClick={() => setflagOms(true)} >
                    <svg width={12} style={{ marginLeft: 5 }}>
                        <use xlinkHref='/sprit.svg#ref'></use>
                    </svg>
                    تغییر پنل معاملاتی
                </div>
                <div style={{ width: 225 }}>
                    <div className={classes['mergeButtons']}>
                        <div>
                            <Button
                                id="basic-button"
                                aria-controls={open ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                onClick={() => handelOpen()}
                            // onMouseMove={handleClick}
                            >
                                <p className={classes['text']} style={{ color: open ? 'red' : '', width: 89 }}>
                                    ورود به سامانه
                                </p>
                            </Button>
                        </div>
                        <div className={classes['line']}></div>
                        <div>
                            <Button
                                id="basic-button"
                                aria-controls={openAccount ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={openAccount ? 'true' : undefined}
                                onClick={() => handelOpenAccount()}
                            // onMouseMove={handleClick}
                            >
                                <p className={classes['text']} style={{ color: openAccount ? 'red' : '', width: 89 }}>
                                    حساب کاربری

                                </p>
                            </Button>
                            {/* <a href={'https://reg.pouyanbroker.ir'}
                                target='_blank'
                                rel="noopener noreferrer">
                                <p className={classes['text']} style={{ width: 89, textAlign: 'center' }}>
                                حساب کاربری
                                </p>
                            </a> */}
                        </div>
                    </div>

                    {
                        open && (
                            <div>
                                <a href={'https://online.pouyanbroker.ir/Account/Login'}
                                    target='_blank'
                                    rel="noopener noreferrer"
                                    className={classes['linkTitle']}
                                >
                                    <span className='title'>
                                        آنلاین پلاس
                                    </span>
                                    <span className={classes['badge']}>
                                        تدبیر
                                    </span>
                                </a>
                                <a href={'https://poyan.exirbroker.com/exir/'}
                                    target='_blank'
                                    rel="noopener noreferrer"
                                    className={classes['linkTitle']}
                                >
                                    <span className='title'>
                                        اکسیر
                                    </span>
                                    <span className={classes['badge']}>
                                        رایان
                                    </span>
                                </a>
                            </div>
                        )
                    }

                    {
                        openAccount && (
                            <div>
                                <a href={'https://reg.pouyanbroker.ir'}
                                    target='_blank'
                                    rel="noopener noreferrer"
                                    className={classes['linkTitle']}
                                >
                                    <span className='title'>
                                        افتتاح حساب
                                    </span>
                                </a>
                                <a href={'https://ehraz.pouyanbroker.ir/'}
                                    target='_blank'
                                    rel="noopener noreferrer"
                                    className={classes['linkTitle']}
                                >
                                    <span className='title'>
                                        احراز هویت غیر حضوری
                                    </span>
                                </a>
                            </div>
                        )
                    }
                </div>


            </div>

        </div>
    );



    return (
        <div style={{ width: '100%', }}>
            <React.Fragment>
                <Box className={classes.root}>
                    <Box>
                        <Link to="/">
                            <img
                                height={'auto'}
                                width={211}
                                src={
                                    home
                                        ? '/assets/images/logoWhite.png'
                                        : !flagHeader ? '/assets/images/logo.png' : '/assets/images/logoWhite.png'
                                }
                                alt=''
                            />
                        </Link>
                    </Box>
                    <Box className={classes.buttuns}>
                        <svg
                            className={classes.navbar}
                            onClick={toggleDrawer("right", true)}
                        >
                            <use xlinkHref="/sprit.svg#navbar"></use>
                        </svg>
                    </Box>
                </Box>

                {/* <Button onClick={toggleDrawer("right", true)}>{"right"}</Button> */}
                <SwipeableDrawer
                    style={{ zIndex: 10000 }}
                    anchor={"right"}
                    open={state["right"]}
                    onClose={toggleDrawer("right", false)}
                    onOpen={toggleDrawer("right", true)}

                >
                    {list("right")}
                </SwipeableDrawer>
            </React.Fragment>
        </div>
    )
}
